import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react'; // This function returns input images along with webP images
// It duplicates the images and create webp image format and add it to the srcList.
// webp images are added first to the list so that if any browser doesn't support it, it can fallback

export var getWebPImageSource = images => {
  return {
    images: images.map(image => {
      return _objectSpread(_objectSpread({}, image), {}, {
        url: image.url.replace(/\.[^.]+$/, '.webp')
      });
    }),
    type: 'image/webp'
  };
};
export var getProductImageSources = _ref => {
  var images = _ref.sizes,
      isVideo = _ref.isVideo,
      videoPath = _ref.videoPath;
  return [{
    images,
    isVideo,
    videoPath
  }];
}; // hook to return list of images

export default function useProductImages(_ref2) {
  var _ref2$product = _ref2.product,
      product = _ref2$product === void 0 ? {} : _ref2$product,
      imagesFromArgs = _ref2.images,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'default' : _ref2$type,
      _ref2$renderWebP = _ref2.renderWebP,
      renderWebP = _ref2$renderWebP === void 0 ? false : _ref2$renderWebP;
  var images = imagesFromArgs || product.images || product.productImages || product.imageSets || {}; // Retrieve the correct type of images (default or plus),
  // falling back to default if no plus images exist

  return useMemo(() => {
    var imageSet;

    if (images.length) {
      imageSet = images;
    } else {
      if (Array.isArray(images[type])) {
        if (type === 'default') {
          imageSet = images.default;
        } else {
          var _images$type;

          imageSet = (_images$type = images[type]) !== null && _images$type !== void 0 && _images$type.length ? images[type] : images.default || [];
        }
      } else {
        // `product.imageSets` has `images` nested inside of imageSet[type] object.
        // This catches data structure with `imageSet[type].images` array
        if (type === 'default' && images.default) {
          var _images$default;

          imageSet = ((_images$default = images.default) === null || _images$default === void 0 ? void 0 : _images$default.images) || [];
        } else {
          var _images$type2, _images$default2;

          imageSet = (_images$type2 = images[type]) !== null && _images$type2 !== void 0 && _images$type2.images.length ? images[type].images : ((_images$default2 = images.default) === null || _images$default2 === void 0 ? void 0 : _images$default2.images) || [];
        }
      }
    }

    if (!imageSet || !imageSet.length) {
      return [];
    }

    var imageList = imageSet.map(getProductImageSources);

    if (renderWebP) {
      return imageList.map(sources => [getWebPImageSource(sources[0].images), ...sources]);
    } else {
      return imageList;
    }
  }, [renderWebP, images, type]);
}